// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___Wpj7","controls":"styles_controls__1WKy4","charLimit":"styles_charLimit__qi_Kf","input":"styles_input__3lfwH","send":"styles_send__Oam2b"};